import { useState, useEffect, useRef } from 'react';

export const useTypewriter = (text, speed = 10) => {
    const [displayedText, setDisplayedText] = useState('');
    const targetTextRef = useRef(text);
    const currentIndexRef = useRef(0);
    const intervalRef = useRef(null);

    // Update the target text ref whenever the text prop changes.
    useEffect(() => {
        targetTextRef.current = text;
    }, [text]);

    // Effect to manage the animation interval.
    useEffect(() => {
        // Function to handle a single step of the animation.
        const animate = () => {
            const currentTarget = targetTextRef.current;
            const currentIndex = currentIndexRef.current;

            if (currentIndex < currentTarget.length) {
                setDisplayedText(currentTarget.substring(0, currentIndex + 1));
                currentIndexRef.current += 1;
            } else {
                // Stop the interval when the text is fully displayed.
                if (intervalRef.current) {
                    clearInterval(intervalRef.current);
                    intervalRef.current = null;
                }
            }
        };

        // Start a new interval only if there's text to animate and no interval is running.
        if (text.length > 0 && !intervalRef.current) {
            // Reset if the text is new
            if (currentIndexRef.current >= targetTextRef.current.length) {
                 currentIndexRef.current = 0;
                 setDisplayedText('');
            }
            intervalRef.current = setInterval(animate, speed);
        }
        
        // Cleanup on unmount or when speed changes.
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        };
    }, [speed, text]); // Rerunning this effect when text changes is necessary to restart the interval for new streams.

    return displayedText;
};
